// eslint-disable-next-line @typescript-eslint/no-unused-vars
import Icons, { IconsProps } from '../Icons';

// https://www.zhangxinxu.com/sp/svgo/

export default function (props: IconsProps) {
  return (
    <Icons {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
        <rect x="0.5625" y="0.839844" width="16" height="16" rx="8" fill="#77837A" />
        <rect x="0.5625" y="0.839844" width="16" height="16" rx="8" stroke="white" />
        <path
          d="M3.82852 14.0392C3.7174 14.0059 3.62029 13.9476 3.53718 13.8645C3.45363 13.781 3.39518 13.6836 3.36185 13.5725L13.2952 3.63919C13.4063 3.67253 13.5036 3.73075 13.5872 3.81386C13.6703 3.89741 13.7341 3.99475 13.7785 4.10586L3.82852 14.0392ZM3.22852 9.85586V8.90586L8.62852 3.50586H9.57852L3.22852 9.85586ZM3.22852 5.07253V4.58919C3.22852 4.27808 3.3314 4.01986 3.53718 3.81453C3.74252 3.60875 4.00074 3.50586 4.31185 3.50586H4.79518L3.22852 5.07253ZM12.3285 14.1725L13.8952 12.6059V13.0892C13.8952 13.4003 13.7925 13.6587 13.5872 13.8645C13.3814 14.0699 13.123 14.1725 12.8118 14.1725H12.3285ZM7.54518 14.1725L13.8952 7.82253V8.77253L8.49518 14.1725H7.54518Z"
          fill="white"
        />
      </svg>
    </Icons>
  );
}
